import type { NodeSpec } from 'prosemirror-model';

/**
 * ProseMirror node spec for inline entity mentions.
 *
 * Stored as an atomic inline node so the chip is an indivisible unit in the
 * editor — selecting, deleting, copy/pasting all treat it as one.
 *
 * Attrs:
 *   entityId  — canonical entity _id (required)
 *   entityType — optional, lets hover cards route to the right renderer without
 *                a fetch for types that prerender (e.g. Communication.Thread).
 *   label     — display text (non-authoritative; hover card uses fetched name).
 */
export const ENTITY_MENTION_NODE_NAME = 'entity_mention';

export const entityMentionSpec: NodeSpec = {
  inline: true,
  atom: true,
  selectable: true,
  draggable: true,
  group: 'inline',
  attrs: {
    entityId: { default: '' },
    entityType: { default: null },
    label: { default: '' },
  },
  parseDOM: [
    {
      tag: 'span[data-entity-id][data-entity-mention]',
      getAttrs(dom: HTMLElement | string) {
        if (typeof dom === 'string') return false;
        const entityId = dom.getAttribute('data-entity-id') || '';
        if (!entityId) return false;
        return {
          entityId,
          entityType: dom.getAttribute('data-entity-type') || null,
          label: dom.getAttribute('data-entity-label') || dom.textContent || '',
        };
      },
    },
  ],
  toDOM(node) {
    return [
      'span',
      {
        'data-entity-mention': 'true',
        'data-entity-id': node.attrs.entityId,
        'data-entity-type': node.attrs.entityType ?? '',
        'data-entity-label': node.attrs.label,
        class: 'entity-mention-chip',
      },
      node.attrs.label || '',
    ];
  },
};
